export default __webpack_public_path__ + "static/media/Pause.4e820515.png";